// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__243xq","notes":"Notes_notes__2NI_y"};